import React from 'react';
import { useField } from 'formik';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { formatDate } from '../../../services';

interface IProps {
  name: string;
  labelText: string;
  disabled?: boolean;
  required?: boolean;
}

const CALENDAR_DATE_FORMAT = 'dd.MM.yyyy';

const DateInput = ({
  name,
  labelText,
  disabled = false,
  required = false,
}: IProps) => {
  const [field, meta, helpers] = useField(name);

  return (
    <div className="form-group">
      {labelText && (
        <div className="label-wrapper">
          <label htmlFor={field.name}>
            {required && <span className="required-indicator">*</span>}
            {labelText}
          </label>
        </div>
      )}
      <DatePicker
        {...field}
        dateFormat={CALENDAR_DATE_FORMAT}
        value={field?.value && new Date(field.value).toString().substring(4, 15)}
        selected={field?.value && new Date(field?.value)}
        className={`form-control ${meta.error && 'is-invalid'}`}
        name={field.name}
        id={field.name}
        onChange={val => {
          if (val) {
            helpers.setValue(new Date(val as Date).toISOString());
          }
        }}
        disabled={disabled}
      />
      {meta.error && <p className="error-wrapper">{meta.error}</p>}
    </div>
  );
};

export { DateInput };
